import $api from "@/frontend/shared/api/axios";
import { CompetitorsSchema, TCompetitor } from "@/libs/models/portfolio-companies";

export async function getFounderAddedCompetitors() {
  const response = await $api.get<{ data: TCompetitor[] }>("/founder-revisions/competitors");
  const parsed = CompetitorsSchema.parse(response.data.data);
  return parsed;
}
